var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import * as _ from 'lodash';
var CalibrationMarkComponent = /** @class */ (function (_super) {
    __extends(CalibrationMarkComponent, _super);
    function CalibrationMarkComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.active = false;
        _this._defaultCalibrationMarkDetailData = {
            calibrationDetail: {
                masterCalibrations: 10,
                subCalibrations: 5,
                calibrationColor: '#333333',
            },
            showCalibrationDigit: true,
            calibrationDigitDetail: {
                integerDigits: 3,
                fractionDigits: 0,
                calibrationDigitFont: {
                    fontSize: '12px',
                    isBold: false,
                    isItalic: false,
                    isUnderline: false,
                    color: '#333333',
                    fontFamily: 'sans-serif'
                }
            }
        };
        _this._defaultPercentageFont = {
            fontSize: '12px',
            isBold: false,
            isItalic: false,
            isUnderline: false,
            color: '#333333'
        };
        return _this;
    }
    Object.defineProperty(CalibrationMarkComponent.prototype, "showCalibration", {
        get: function () {
            return this.data.showCalibration;
        },
        set: function (val) {
            this.data.showCalibration = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "calibrationDetail", {
        get: function () {
            return this.data.calibrationMarkDetail.calibrationDetail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "showCalibrationDigit", {
        get: function () {
            return this.data.calibrationMarkDetail.showCalibrationDigit;
        },
        set: function (val) {
            this.data.calibrationMarkDetail.showCalibrationDigit = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "calibrationDigitDetail", {
        get: function () {
            return this.data.calibrationMarkDetail.calibrationDigitDetail;
        },
        set: function (val) {
            this.data.calibrationMarkDetail.calibrationDigitDetail = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "integerDigits", {
        get: function () {
            return this.calibrationDigitDetail.integerDigits;
        },
        set: function (val) {
            this.calibrationDigitDetail.integerDigits = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "fractionDigits", {
        get: function () {
            return this.calibrationDigitDetail.fractionDigits;
        },
        set: function (val) {
            this.calibrationDigitDetail.fractionDigits = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "calibrationDigitFont", {
        get: function () {
            return this.calibrationDigitDetail.calibrationDigitFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "showPercentage", {
        get: function () {
            return this.data.showPercentage;
        },
        set: function (value) {
            this.data.showPercentage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalibrationMarkComponent.prototype, "percentageFont", {
        get: function () {
            return this.data.percentageFont;
        },
        set: function (value) {
            this.data.percentageFont = value;
        },
        enumerable: true,
        configurable: true
    });
    CalibrationMarkComponent.prototype.showPercentageChanged = function () {
        if (this.showPercentage) {
            this.percentageFont = _.cloneDeep(this._percentageFontBak || this._defaultPercentageFont);
        }
        else {
            this.percentageFont = undefined;
        }
    };
    Object.defineProperty(CalibrationMarkComponent.prototype, "defaultCalibrationDigitDetail", {
        get: function () {
            return this._defaultCalibrationMarkDetailData.calibrationDigitDetail;
        },
        enumerable: true,
        configurable: true
    });
    CalibrationMarkComponent.prototype.showCalibrationChanged = function () {
        if (this.showCalibration) {
            this.data.calibrationMarkDetail = this.meterCalibrationMarkBak || this._defaultCalibrationMarkDetailData;
        }
        else {
            this.meterCalibrationMarkBak = this.data.calibrationMarkDetail;
            this.data.calibrationMarkDetail = undefined;
        }
    };
    CalibrationMarkComponent.prototype.showCalibrationDigitChanged = function () {
        if (this.showCalibrationDigit) {
            this.calibrationDigitDetail = this.calibrationDigitDetailBak || this.defaultCalibrationDigitDetail;
        }
        else {
            this.calibrationDigitDetailBak = this.calibrationDigitDetail;
            this.calibrationDigitDetail = undefined;
        }
    };
    CalibrationMarkComponent.prototype.validateIntegerFractionSum = function (currentFormControl) {
        var allControlls = currentFormControl.parent.controls;
        var integerDigitControl = allControlls['IntegerDigit'];
        var fractionDigitControl = allControlls['FractionDigit'];
        if (!integerDigitControl || !fractionDigitControl) {
            return undefined;
        }
        if (_.isNil(fractionDigitControl.value) || _.isNil(integerDigitControl.value)) {
            return undefined;
        }
        if (!_.isNumber(fractionDigitControl.value) || !_.isNumber(integerDigitControl.value)) {
            return undefined;
        }
        if (fractionDigitControl.value + integerDigitControl.value > 10) {
            return { 'integerFractionDigitSumError': true };
        }
        else {
            if (integerDigitControl.errors) {
                delete integerDigitControl.errors.integerFractionDigitSumError;
                if (Object.keys(integerDigitControl.errors || {}).length === 0) {
                    integerDigitControl.setErrors(undefined);
                }
            }
            if (fractionDigitControl.errors) {
                delete fractionDigitControl.errors.integerFractionDigitSumError;
                if (Object.keys(fractionDigitControl.errors || {}).length === 0) {
                    fractionDigitControl.setErrors(undefined);
                }
            }
            return undefined;
        }
    };
    CalibrationMarkComponent.prototype.validate = function () {
        return true;
    };
    CalibrationMarkComponent.prototype.ngOnChanges = function (changes) {
        var currentData = changes['data'].currentValue;
        if (currentData.showPercentage && !currentData.percentageFont) {
            currentData.percentageFont = this._defaultPercentageFont;
        }
        this.active = !!currentData;
    };
    CalibrationMarkComponent.prototype.correctIntegerDigit = function (val) {
        if (Number(val) < 1) {
            this.integerDigits = 1;
        }
    };
    CalibrationMarkComponent.prototype.setCalibrationColor = function (color) {
        this.calibrationDetail.calibrationColor = color;
    };
    __decorate([
        Input()
    ], CalibrationMarkComponent.prototype, "data", void 0);
    __decorate([
        Input()
    ], CalibrationMarkComponent.prototype, "displayPercentage", void 0);
    CalibrationMarkComponent = __decorate([
        Component({
            selector: 'calibration-mark',
            styles: [".full-width{ width: 100%; } .inline-control{ display: inline-block; select{ width: 144px !important; } } .lbTop{ margin-top: 5px; } .row.lbTop{ margin-top: 10px; } .lbCalibration{ margin-top: 10px; label{ line-height: 13px; } } .warning{ color:red; } .warning.first{ margin-left: 10px; } .float-left{ float: left; } .float-right{ float: right; } .clear{ width:100%; height:0; clear:both; } .lbTop-large{ margin-top: 10px; } .add-margin{ margin-left: 10px; } .decrease-margin-bottom{ margin-bottom: -10px; } .increase-margin-top{ margin-top: 5px; } .percentage-row{ margin-bottom: 10px; } .color-picker{ width: 100px; } "],
            template: "<div class=\"fe-modal-body\" provide-parent-forms> <div *ngIf=\"active\"> <div *ngIf='displayPercentage'> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" [(ngModel)]=\"showPercentage\" name=\"ShowPercentage\" (ngModelChange)=\"showPercentageChanged()\" /> <span>{{lc('ShowPercentage')}}</span> </label> </div> <div class=\"fe-modal-content\" *ngIf=\"showPercentage\"> <label class=\"form-inline-label\">{{lc('FontProperty')}}:</label> <div class=\"inline-control\"> <font-setting [FontFamilyEnabled]=\"false\" [font]=\"percentageFont\"></font-setting> </div> </div> </div> <div> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" [(ngModel)]=\"showCalibration\" name=\"ShowCalibration\" (ngModelChange)=\"showCalibrationChanged()\" /> <span>{{lc('ShowCalibration')}}</span> </label> </div> <div class=\"fe-modal-content\" *ngIf=\"showCalibration\"> <div class=\"clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc('MasterCalibrationCount')}}:</div> <input type=\"number\" name=\"masterCalibrations\" class=\"fe-vertical-input\" #masterCalibrations=\"ngModel\" not-negative-integer [(ngModel)]=\"calibrationDetail.masterCalibrations\"> <div class=\"has-danger fe-option-head\" *ngIf=\"masterCalibrations.invalid && (masterCalibrations.dirty || masterCalibrations.touched)\"> <div class=\"form-control-feedback\"> {{lc('MasterCalibrationCountError')}} </div> </div> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc('SubCalibrationCount')}}:</div> <input type=\"number\" name=\"subCalibrations\" class=\"fe-vertical-input\" #subCalibrations=\"ngModel\" not-negative-integer [(ngModel)]=\"calibrationDetail.subCalibrations\"> <div class=\"has-danger fe-option-head\" *ngIf=\"subCalibrations.invalid && (subCalibrations.dirty || subCalibrations.touched)\"> <div class=\"form-control-feedback\"> {{lc('SubCalibrationCountError')}} </div> </div> </div> </div> <div class=\"fe-transverse-label clearfix margin-top-10\"> <div class=\"fe-transverse-title\">{{lc('CalibrationColor')}}:</div> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"calibrationDetail.calibrationColor\" (sentColor)=\"setCalibrationColor($event)\"></color-picker> </div> </div> <div class=\"fe-option-head\" *ngIf=\"showCalibration\"> <label> <input type=\"checkBox\" [(ngModel)]=\"showCalibrationDigit\" name=\"ShowCalibrationDigit\" (ngModelChange)=\"showCalibrationDigitChanged()\" /> <span>{{lc('ShowCalibrationDigit')}}</span> </label> </div> <div class=\"clearfix\" *ngIf=\"showCalibration && showCalibrationDigit\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"IntegerDigit\")}}:</div> <input type=\"number\" name=\"IntegerDigit\" class=\"fe-vertical-input\" #IntegerDigit=\"ngModel\" not-negative-integer (change)=\"correctIntegerDigit($event.target.value)\" [custom-func-validate]=\"validateIntegerFractionSum\" [(ngModel)]=\"integerDigits\" required> <div class=\"has-danger fe-option-head\" *ngIf=\"IntegerDigit.invalid && (IntegerDigit.dirty || IntegerDigit.touched)\"> <div class=\"form-control-feedback\"> <span *ngIf=\"IntegerDigit.errors.required\"> {{l('Required')}} </span> <span *ngIf=\"IntegerDigit.errors.notNegativeInteger\"> {{l('NotNegativeInteger')}} </span> <span *ngIf=\"IntegerDigit.errors.integerFractionDigitSumError\">{{lc('MeterCalibrationIntegerFractionSumCheck')}}</span> </div> </div> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"FractionDigit\")}}:</div> <input type=\"number\" name=\"FractionDigit\" [custom-func-validate]=\"validateIntegerFractionSum\" class=\"fe-vertical-input\" #FractionDigit=\"ngModel\" not-negative-integer [(ngModel)]=\"fractionDigits\" required> <div class=\"has-danger fe-option-head\" *ngIf=\"FractionDigit.invalid && (FractionDigit.dirty || FractionDigit.touched)\"> <div class=\"form-control-feedback\"> <span *ngIf=\"FractionDigit.errors.required\"> {{l('Required')}}</span> <span *ngIf=\"FractionDigit.errors.notNegativeInteger\"> {{l('NotNegativeInteger')}}</span> <span *ngIf=\"FractionDigit.errors.integerFractionDigitSumError\">{{lc('MeterCalibrationIntegerFractionSumCheck')}}</span> </div> </div> </div> </div> <div *ngIf=\"showCalibrationDigit\" class=\"margin-top-10\"> <label class=\"form-inline-label\">{{lc('FontProperty')}}:</label> <div class=\"inline-control\"> <font-setting [FontFamilyEnabled]=\"false\" [font]=\"calibrationDigitFont\"></font-setting> </div> </div> </div> </div> </div> </div>"
        })
    ], CalibrationMarkComponent);
    return CalibrationMarkComponent;
}(ConfigureComponentBase));
export { CalibrationMarkComponent };
